import { tracking, useNamespace } from '@bark/bark-core';
import AdditionalDetails, { shouldShowAdditionalDetails } from './additional-details';

export const AfterBarkPlacedModal = (methodOptions = {}) => {
	/**
	 * Options for this class
	 * @type {object}
	 */
	const opts = Object.assign(
		{
			hasSellers: null,
			project: null,
			onBeforeShowAdditionDetails: (settings) => {},
			callbackAfterComplete: null,
		},
		methodOptions,
	);

	const additionalDetailsModalSelector = '#additional-details-modal-with-progress';

	const { id: projectId, attributes: project } = opts.project;

	const { hideLoading } = window.Bark;

	const successModal = $('#post-bark-welcome-modal');

	const state = {
		additionalDetailsModalOpen: false,
		showSuccessModal: false,
	};

	const bindEvents = () => {
		$('.js-modal-navigate', successModal)
			.off('click.nav')
			.on('click.nav', ({ target }) => {
				const $target = $(target);
				const { dir } = $target.data();
				const currentPage = $target.closest('.js-post-bark-modal-page');
				const pages = $('.js-post-bark-modal-page');
				const indexOneKeyed = pages.index(currentPage) + 1;

				if (dir === 'fwd') {
					if (indexOneKeyed < pages.length) {
						pages.addClass('d-none');
						currentPage.next('.js-post-bark-modal-page').removeClass('d-none');
					} else {
						$('.modal').modal('hide');
						typeof opts.callbackAfterComplete === 'function' &&
							opts.callbackAfterComplete();
					}
				} else if (dir === 'back') {
					if (indexOneKeyed - 1 !== 0) {
						pages.addClass('d-none');
						currentPage.prev('.js-post-bark-modal-page').removeClass('d-none');
					}
				}
			});

		$('.js-modal-back-to-additional', successModal)
			.off('click.backToAdditional')
			.on('click.backToAdditional', () => {
				$('.modal').modal('hide');
				$(additionalDetailsModalSelector).modal('show');
			});
	};

	/**
	 * Show the additional details modal
	 */
	const showAdditionalDetailsModal = async () => {
		const experimentParams = await AdditionalDetailsDesignPicker({
			subheadingMarkdown: project.additional_details_settings.subheader_text,
			allowFiles: project.additional_details_settings.can_attach_files,
		});

		const additionalDetailOptions = Object.assign(
			{
				modalSelector: additionalDetailsModalSelector,
				placeholderText: project.additional_details_settings.placeholder_text,
				project,
				projectId,
			},
			experimentParams,
		);

		additionalDetailOptions.onInit = () => {
			tracking('After Place Bark', 'Additional Details - view', {
				usingCustomSubHeader: project.additional_details_settings.subheader_text !== null,
				allowAttachedFiles: project.additional_details_settings.can_attach_files,
				projectId: projectId,
			});
		};
		additionalDetailOptions.onBeforeSkip =
			additionalDetailOptions.onSubmitSuccess =
			additionalDetailOptions.onSubmitFail =
				() => {
					$('.modal').modal('hide');
					state.additionalDetailsModalOpen = false;

					if (state.showSuccessModal) {
						// Only show if there are no sellers
						configureAndShowSuccessModal(false, true);
					} else {
						typeof opts.callbackAfterComplete === 'function' &&
							opts.callbackAfterComplete();
					}
				};

		additionalDetailOptions.onContinueAfterSubmitted = () => {
			$('.modal').modal('hide');
			successModal.modal('show');
		};

		if (opts.onBeforeShowAdditionDetails(additionalDetailOptions) === false) {
			return;
		}

		hideLoading();

		state.additionalDetailsModalOpen = true;
		AdditionalDetails(additionalDetailOptions);
	};

	/**
	 * Configure and then show the success modal
	 * @param {boolean} showSuccessPage
	 * @param {boolean} hadAdditionalDetails
	 */
	const configureAndShowSuccessModal = (
		showSuccessPage,
		hadAdditionalDetails = false,
	) => {
		let firstPage;
		let backBtn;

		if (!showSuccessPage) {
			$('.js-post-bark-tick-page').remove();
		}

		// no bnb section loaded so remove
		if (!$('.js-bark-placed-bnb-section').children().length) {
			$('.js-post-bark-bnb-section').remove();
		}

		if (hadAdditionalDetails) {
			$('.js-modal-back-to-additional', firstPage).removeClass('d-none');
		}

		firstPage = $('.js-post-bark-modal-page:first', successModal).removeClass('d-none');
		backBtn = $('.js-modal-navigate[data-dir="back"]', firstPage).addClass('d-none');

		if (!hadAdditionalDetails) {
			backBtn.parent().toggleClass('justify-content-between justify-content-end');
		}

		successModal.modal('show');
	};

	/**
	 * Perform whatever action is required after a Bark is placed
	 */
	const showSuccessModal = async () => {
		await useNamespace('buyer_placed_bark-additional-services-upsell-modal');

		state.showSuccessModal = true;
		if (!state.additionalDetailsModalOpen) {
			configureAndShowSuccessModal(true);
		}
	};

	bindEvents();

	return {
		showSuccessModal,
		showAdditionalDetailsModal,
	};
};

export const showAdditionalDetailsIfNeededAfterBark = (
	{ firstView, project },
	callbackAfterComplete,
) => {
	if (shouldShowAdditionalDetails(firstView, project.attributes)) {
		AfterBarkPlacedModal({ project, callbackAfterComplete }).showAdditionalDetailsModal();
	} else {
		typeof callbackAfterComplete === 'function' && callbackAfterComplete();
	}
};
